import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    requestAnimationFrame(() => {
      this.element.classList.remove('opacity-0', 'scale-95')
      this.element.classList.add('opacity-100', 'scale-100')
    })

    setTimeout(() => this.close(), 5000)
  }

  close() {
    this.element.classList.add('opacity-0', 'scale-95')
    this.element.classList.remove('opacity-100', 'scale-100')
    this.element.addEventListener('transitionend', () => {
      this.element.remove()
    }, { once: true })
  }
}
